<template>
  <div class="div1">
    <!-- <ButtonPrime:
            :label="$t('generateReportBtn')"
            :style="{ width: '120px' }"
            class="p-button header_button"
            @click="generatePdf()"
          /> -->
      <div v-for="(ship, shipIndex) in this.ships" :key="shipIndex" class="container" id="ElementoAImprimir" style="padding-bottom: 15px;">
        <div v-if="shipsChecked[shipIndex] == true">
        <!-- <div data-page-break="true"></div> -->
          <!-- Datos del usuario y los principales del barco -->
          <div class="formgrid grid">
              <!-- Datos del usuario -->
              <div class="field col" style="padding-left: 4%; padding-right: 10%;">
                  <div class="output-box" >
                      <h2 style="text-align: left; padding-bottom: 10px;">{{ $t('userDataTitle') }}: </h2>
                      <p style="text-align: left; padding-bottom: 10px;">{{ $t('usersFullName') }}: {{userFullName}}</p>
                      <p style="text-align: left; padding-bottom: 10px;">{{ $t('userDNI') }}: {{ userDNI }}</p>
                      <p style="text-align: left; padding-bottom: 10px;">{{ $t('userCIF') }}: {{ userCIF }}</p>
                      <p style="text-align: left; padding-bottom: 10px;">{{ $t('userCompany') }}: {{ userCompany }}</p>
                  </div>
              </div>
              <div class="field col" style="padding-left: 10%; padding-right: 4%;">
                  <!-- Datos principal del barco -->
                  <div class="output-box">
                      <h2 style="text-align: left; padding-bottom: 24px;">{{ $t('shipDataTitle') }}</h2>
                      <p style="text-align: left; padding-bottom: 10px;">{{ $t('shipName') }}: {{ ship.name }}</p>
                      <p style="text-align: left; padding-bottom: 10px;">{{ $t('imoNumber') }}: {{ ship.imo }}</p>
                      <p style="text-align: left; padding-bottom: 24px;">{{ $t('shipType') }}: {{ ship.shipType.name }}</p>
                  </div>
              </div>
          </div>

          <!-- Datos secundarios del barco -->
          <div class="formgrid grid">
              <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                  <div class="output-box" >
                      <h2 style="text-align: left">{{ $t('shipGeneralData') }}</h2>
                      <div class="formgrid grid" style="padding-top: 15px;">
                        <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t('totalDistance') }} (mn): {{ ship.totalDistance }}</p>
                        </div>
                        <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p v-if="ship.gt != null" style="text-align: left;">{{ $t('grossTonnage') }} - GT (t): {{ ship.gt }}</p>
                            <p v-else style="text-align: left;">{{ $t('grossTonnage') }} - GT (t): ---</p>
                        </div>
                        <div class="field col" style="padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("capacityDeadWeight") }} - DWT (t): {{ ship.dwt }}</p>
                        </div>  
                      </div>
                      <div class="formgrid grid" style="padding-top: 15px;">
                        <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("dateKeelLaid") }}: {{ dtFormat(ship.keelLaidDownDate,'DD/MM/YYYY') }}</p>
                        </div>
                        <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("dateSigning") }}: {{ dtFormat(ship.contractSignInDate,'DD/MM/YYYY') }}</p>
                        </div>
                        <div class="field col" style="padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("dataDelivery") }}: {{ dtFormat(ship.shipDeliveredDate,'DD/MM/YYYY') }}</p>
                        </div>  
                      </div>
                      <div class="formgrid grid" style="padding-top: 15px;">
                        <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("iceClass") }}: {{ ship.iceClassType.name }}</p>
                        </div>
                        <div v-if="ship.iceClassType.name != 'None'" class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("lengthOverall") }} LOA (m): {{ ship.loa }}</p>
                        </div>
                        <div v-if="ship.iceClassType.name != 'None'" class="field col" style="padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("lengthbtwPerpendicular") }} - LPP (m): {{ ship.lpp }}</p>
                        </div>  
                      </div>
                      <div class="formgrid grid" style="padding-top: 15px;">
                        <div v-if="ship.iceClassType.name != 'None'" class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("displacementVolume") }} - Vd (m<sup>3</sup>): {{ ship.displacementVolume }}</p>
                        </div>
                        <div v-if="ship.iceClassType.name != 'None'" class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("summerLoad") }} - ds (m): {{ ship.ds }}</p>
                        </div>
                        <div v-if="ship.iceClassType.name != 'None'" class="field col" style="padding-right: 4%;">
                            <p style="text-align: left;">{{ $t("breadth") }}:  {{ ship.bs }}</p>
                        </div>  
                      </div>
                  </div>
              </div>
          </div>

          <!-- Datos de los combustibles del barco -->
          <div class="formgrid grid">
            <div class="field col" style="padding-left: 4%; padding-right: 4%;">
              <div class="output-box" >
                  <h1 style="text-align: left">{{ $t("shipFuelData") }} </h1>

                  <div style="padding-top: 15px; padding-bottom: 15px;"></div>

                  <FuelConsumptionTable :fuelArray = "ship.fuelConsumption"></FuelConsumptionTable>
                  
                  <div style="padding-top: 15px; padding-bottom: 15px;"></div>

                  <!-- Datos de gasto de combustible en hielo -->
                  <div class="input-box" style="padding-right: 4%;">
                    <div class="formgrid grid">
                      <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                        <p style="text-align: center;">{{ $t('shipGWP') }}: {{ ship.dataForETS.selectedGWPOPtion }}</p>
                      </div>
                      <!-- Tabla para imprimir por año los datos del fuelEU -->   
                    </div>
                    <div style="padding-top: 15px; padding-bottom: 15px;" v-if="hasFuelEUTableData(ship)"></div>
                    <table class="styled-table" v-if="hasFuelEUTableData(ship)">
                      <thead>
                        <tr>
                          <th scope="col" id="firstColumn"></th>
                          <th v-if="ship.iceClassType.name != 'None'" scope="col">{{ $t('inputAnualDistanceOnIce') }} (mn)</th>
                          <th scope="col">OPS (MJ):</th>
                          <th scope="col">{{ $t('inputWindPower') }} (Pwind):</th>
                          <th scope="col">{{ $t('inputShipPropulsionPower') }} (Pprop):</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in sortedFuelEUTable(ship)" :key="index">
                        <td>
                          <p style="text-align: left">{{ item.year }}</p>
                        </td>
                        <td v-if="ship.iceClassType.name != 'None'">
                          <p style="text-align: center;">{{ item.anualDistanceOnIce }}</p>
                          <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                        </td>
                        <td>
                          <p style="text-align: center;">{{ item.OPS }}</p>
                          <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                        </td>
                        <td>
                          <p style="text-align: center;">{{ item.windPower }}</p>
                          <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                        </td>
                        <td>
                          <p style="text-align: center;">{{ item.propulsionPower }}</p>
                          <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                        </td>
                        </tr>
                      </tbody>
                    </table>
                    <div v-else>
                      <p style="text-align: center;">{{ $t('noExtraDataFuelEU') }}</p>
                    </div>

                    <div class="seperatorThin" style="padding-bottom: 30px;" v-if="ship.iceClassType.name != 'None' && hasIceNavConsumption(ship)">
                     <h5></h5>
                    </div>
                    <div v-else style="padding-top: 15px; padding-bottom: 15px"></div>

                    <table class="styled-table" v-if="ship.iceClassType.name != 'None' && hasIceNavConsumption(ship)">
                      <thead>
                        <tr>
                          <th scope="col" id="firstColumn"></th>
                          <th scope="col" style="text-align: center">{{ $t('fuelIceTable') }} (mn)</th>
                          </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in sortedIceNavConsumption(ship)" :key="index">
                        <td>
                          <p style="text-align: left">{{ item.year }}</p>
                        </td>
                        <td>
                          <table class="styled-table">
                            <thead>
                              <th scope="col">{{ $t('fuelName') }}</th>
                              <th scope="col">{{ $t('anualIceConsumption') }} (t)</th>
                              <th scope="col">{{ $t('additionalEnergyPercentage') }} (%)</th>
                            </thead>
                            <tbody>
                              <tr v-for="(fuel, index) in item.arrayAuxFuelIce" :key="index">
                                <td>
                                  <p style="text-align: center;">{{ fuel.name }}</p>
                                </td>
                                <td>
                                  <p style="text-align: center;">{{ fuel.anualIceConsumption }}</p>
                                </td>
                                <td>
                                  <p style="text-align: center;">{{ fuel.additionalEnergyPercentage }}</p>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <!-- <p style="text-align: center;">{{ item.anualAdjustedConsumption }}</p> -->
                          <!-- <input class="input-style" v-model="item.FCvoyage" type="number" /> -->
                        </td>
                      </tr>
                      </tbody>
                    </table>
                    <div v-else-if="ship.iceClassType.name != 'None'">
                      <p style="text-align: center;">{{ $t('fuelIceTableMessage') }}</p>
                    </div>

                  </div>

                  <div style="padding-top: 15px; padding-bottom: 15px;"></div> 

                  <!-- Tipo de buque -->
                  <div class="input-box" style="padding-right: 4%;">
                    <div class="formgrid grid">
                      <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                        <p v-if="ship.isChemicalTanker != null && ship.isChemicalTanker != undefined && ship.isChemicalTanker != false" style="text-align: center;">Es un buque tanque quimiquero: Si</p>
                        <p v-else style="text-align: center;">{{ $t('shipIsChemicalTank') }}: No</p>
                      </div>
                      <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                        <p v-if="ship.isChemicalTanker != null && ship.isChemicalTanker != undefined && ship.isChemicalTanker != false" style="text-align: center;">{{ $t('vTanks') }} - Vtanks (m<sup>3</sup>): {{ ship.vTanks }}</p>
                      </div>
                    </div>
                    <div class="formgrid grid">
                      <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                        <p v-if="ship.structuralEnhancement != null && ship.structuralEnhancement != undefined && ship.structuralEnhancement != false" style="text-align: center;">{{ $t('questionShipTanker') }} Si</p>
                        <p v-else style="text-align: center;">{{ $t('questionShipTanker') }} No</p>
                      </div>
                      <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                        <p v-if="ship.structuralEnhancement != null && ship.structuralEnhancement != undefined && ship.structuralEnhancement != false" style="text-align: center;">{{ $t('questionStruturalImprovements') }} Si</p>
                        <p v-else style="text-align: center;">{{ $t('questionStructuralImprovements') }} No</p>
                      </div>
                    </div>
                  </div>

                  <div style="padding-top: 15px; padding-bottom: 15px;"></div> 

                  <!-- Datos del FC -->
                  <div class="input-box">
                    <!-- Tabla para los combustibles con los datos FC para cada uno -->
                    <div>
                      <table class="styled-table">
                        <thead>
                          <tr>
                            <th scope="col">{{ $t("fuelType") }}</th>
                            <th scope="col">FC<sub>voyage</sub> (gr)</th>
                            <th scope="col">FC<sub>boiler</sub> (gr)</th>
                            <th scope="col">FC<sub>others</sub> (gr)</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in ship.dataForCII.arrayFuelVariables" :key="index">
                          <td>
                            <p style="text-align: left">{{ item.fuel.fuel.name }}</p>
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.FCvoyage }}</p>
                            <!-- <input class="input-style" v-model="item.FCvoyage" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.FCboiler }}</p>
                            <!-- <input class="input-style" v-model="item.FCboiler" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.FCothers }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          </tr>
                        </tbody>
                      </table>              
                    </div>
                    <!-- Datos generales del FC -->
                    <div style="padding-top: 15px; padding-bottom: 15px;"></div>
                    <p style="text-align: left; padding-left: 5%;">{{ $t('travelDistance') }} - Dx (m): {{ ship.dataForCII.travelDistance }}</p>
                    <p style="text-align: left; padding-left: 5%; padding-top: 15px;">{{ $t('shipFuelFCelectrical') }}: {{ getFCFuel(ship) }}</p>

                    <div style="padding-top: 15px; padding-bottom: 15px;"></div>
                    <!-- Desarrollo del FCelectrical -->
                    <!-- <div class="input-box" style="width: 150%"> -->
                      <div v-for="(item, index) in filteredFuelVariables(ship)" :key="index" style="padding-left: 10%;">
                        <div v-if="item.fuel.fuel.name == getFCFuel(ship)">
                          <div v-if="item.typeFCelec.name == 'Contenedores refrigerados (reefer)'">
                            <div v-if="item.canMonitorElecConsumption == 'Yes'" class="formgrid grid">
                              <p style="text-align: left" class="field col">{{ $t('selectionFCelectrical') }} - <strong>FC<sub>electrical</sub>:</strong> {{ item.typeFCelec.name }}</p>
                              <p style="text-align: left" class="field col">{{ $t('questionCanMonitorElectricalConsumption') }} {{ item.canMonitorElecConsumption }}</p>
                              <p style="text-align: left" class="field col">Reefer (kWh): {{ item.reefer }}</p>
                            </div>
                            <div v-else>
                              <div  class="formgrid grid">
                                <p style="text-align: left" class="field col">FCelectrical (gr): {{ $t('refrigeratedContainers') }}</p>
                                <!-- <p style="text-align: left" class="field col">¿Puede vigilar el consumo eléctrico? {{ item.canMonitorElecConsumption }}</p> -->
                              </div>
                              <div  class="formgrid grid">
                                <p style="text-align: left" class="field col">{{ $t('daysSea') }}: {{ item.daysSea }}</p>
                                <p style="text-align: left" class="field col">Noc Arrival: {{ item.nocArrival }}</p>
                              </div>
                              <div  class="formgrid grid">
                                <p style="text-align: left" class="field col">{{ $t('daysPort') }}: {{ item.daysPort }}</p>
                                <p style="text-align: left" class="field col">Noc Departure: {{ item.nocDeparture }}</p>
                              </div>
                              <div  class="formgrid grid">
                                <p style="text-align: left" class="field col">{{ $t('numContainers') }}: {{ item.numContainers }}</p>
                              </div>
                            </div>
                          </div>
                          <div v-else-if="item.typeFCelec.name == 'Bombas de descarga eléctricas (discharge)'">
                              <p style="text-align: left" class="field col">FCelectrical (gr): {{ $t('electricBombs') }}</p>
                              <p style="text-align: left" class="field col">Discharge (kWh): {{ (item.discharge).toFixed(2) }}</p>
                              <p style="text-align: left" class="field col">SFOC (g/kWh): {{ (item.SFOC).toFixed(2) }}</p>
                          </div>
                          <div v-else-if="item.typeFCelec.name == 'Sistemas de refrigeración en buques gaseros y GNL (cooling)'">
                              <p style="text-align: left" class="field col">FCelectrical (gr): {{ $t('refrigerationSistems') }}</p>
                              <p style="text-align: left" class="field col">Cooling (kWh): {{ (item.Cooling).toFixed(2) }}</p>
                              <p style="text-align: left" class="field col">SFOC (g/kWh): {{ (item.SFOC).toFixed(2) }}</p>
                          </div>
                        </div>
                      </div>
                    <!-- </div> -->
                  </div>
              </div>
            </div>
          </div>

          <!-- Modificaciones del barco -->
          <div v-if="modificationSelected(shipIndex)" class="formgrid grid" data-page-break="true">
            <div class="field col" style="padding-left: 4%; padding-right: 4%;">
              <div class="output-box">
                <h1 style="text-align: left;">{{ $t('shipModifications') }}</h1>
                <div style="padding-top: 15px; padding-bottom: 15px;"></div>

                <!-- For pora cada modificiación del barco -->
                <div  v-for="(mod, modIndex) in ship.modifications" :key="modIndex">
                  <div v-if="modIndex == this.selectedModifications[shipIndex]">
                    <div style="padding-top: 15px; padding-bottom: 15px;"></div>
                    <!-- <div class="input-box"> -->
                      <h4 style="text-align: left; padding-bottom: 5px;">{{ $t('modifName') }}: {{ mod.name }}</h4>
                      <h4 style="text-align: left; padding-bottom: 5px;">{{ $t('modifDescription') }}: {{ mod.description }}</h4>
                      <h4 style="text-align: left; padding-bottom: 5px;">{{ $t('modifType') }}: {{ mod.type.name }}</h4>

                      <div style="padding-top: 15px; padding-bottom: 15px;"></div> 

                      <!-- Datos principales de la modificacion -->
                      <div class="input-box" style="width: 100%;">
                        <div class="formgrid grid" style="width: 100%;">
                          <div class="field col" style="padding-left: 4%; padding-right: 10%;">
                            <p style="text-align: left;">{{ $t('initialInvestment') }}: {{ mod.economicData.initialInvestment }}</p>
                          </div>
                          <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t('financing') }}: {{ mod.economicData.amountToFinance }}</p>
                          </div>
                        </div>
                        <div class="formgrid grid" style="width: 100%;">
                          <div class="field col" style="padding-left: 4%; padding-right: 10%;">
                            <p style="text-align: left;">{{ $t('annualDiscountRate') }}: {{ mod.economicData.annualDiscountRate }}</p>
                          </div>
                          <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t('neobuqAmountToFinance') }} (€): {{ mod.economicData.amountToFinance }}</p>
                          </div>
                        </div>
                        <div class="formgrid grid" style="width: 100%;">
                          <div class="field col" style="padding-left: 4%; padding-right: 10%;">
                            <p style="text-align: left;">{{ $t('dailyIncome') }} (€): {{ mod.economicData.dailyIncome }}</p>
                          </div>
                          <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t('nominalInterest') }} (%): {{ mod.economicData.nominalInterest }}</p>
                          </div>
                        </div>
                        <div class="formgrid grid" style="width: 100%;">
                          <div class="field col" style="padding-left: 4%; padding-right: 10%;">
                            <p style="text-align: left;">{{ $t('paralizationDays') }}: {{ mod.economicData.paralizationDays }}</p>
                          </div>
                          <div class="field col" style="padding-left: 4%; padding-right: 4%;">
                            <p style="text-align: left;">{{ $t('neobuqAmortizationPeriod') }}: {{ mod.economicData.amortizationPeriod }}</p>
                          </div>
                        </div>
                        <p style="padding-left: 6%; text-align: left;">{{ $t('annualFuelPriceIncrease') }} (%): {{ mod.economicData.annualFuelPriceIncrease }}</p>
                      </div>

                      <div style="padding-top: 15px; padding-bottom: 15px;"></div> 

                      <!-- Tablas Generales de las modificaciones -->
                      
                      <h2 style="text-align: left">{{ $t('incomeChangeTable') }}</h2>
                      <div style="padding-top: 15px; padding-bottom: 15px;"></div> 
                      <!-- Tabla de consumo -->
                      
                      <table class="styled-table" style="width: 100%;">
                        <thead>
                          <tr>
                            <th scope="col">{{ $t('fuelType') }}</th>
                            <th scope="col" style="text-align: center;">{{ $t('consumptionBeforeModif') }}</th>
                            <th scope="col" style="text-align: center;">{{ $t('consumptionAfterModif') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in mod.newFuelConsumption" :key="index">
                          <td>
                            <p style="text-align: left">{{ item.fuel.name }}</p>
                          </td>
                          <td>
                            <p style="text-align: center;">{{ ship.fuelConsumption[index].consumption }}</p>
                            <!-- <input class="input-style" v-model="item.FCvoyage" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.consumption }}</p>
                            <!-- <input class="input-style" v-model="item.FCboiler" type="number" /> -->
                          </td>
                          </tr>
                        </tbody>
                      </table>

                      
                      <div class="seperatorThin" style="padding-bottom: 30px;">
                      <h5></h5>
                      </div>
                      <h2 style="text-align: left">{{ $t('costsAndVariationsTable') }}</h2>
                      <div style="padding-top: 15px; padding-bottom: 15px;"></div> 
                      <!-- Tabla de consumo -->

                      <table class="styled-table" style="width: 100%;">
                        <thead>
                          <tr>
                            <th scope="col" id="firstColumn"></th>
                            <th scope="col" style="text-align: center;">{{ $t('annualFuelCost') }} (€):</th>
                            <th scope="col" style="text-align: center;">{{ $t('variationVariousCosts') }}:</th>
                            <th scope="col" style="text-align: center;">{{ $t('loanInterests') }}:</th>
                            <th scope="col" style="text-align: center;">{{ $t('annualProfitability') }}:</th>
                            <th scope="col" style="text-align: center;">{{ $t('van') }}:</th>
                            <th scope="col" style="text-align: center;">{{ $t('paralizationCost') }} (€):</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in mod.economicData.dataPerYear" :key="index">
                          <td>
                            <p style="text-align: left">{{ item.year }}</p>
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.annualFuelCost }}</p>
                            <!-- <input class="input-style" v-model="item.FCvoyage" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.variationVariousCosts }}</p>
                            <!-- <input class="input-style" v-model="item.FCboiler" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.loanInterests }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.annualProfitability }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.van }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.paralizationCost }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          </tr>
                        </tbody>
                      </table>

                      <div class="seperatorThin" style="padding-bottom: 30px;">
                      <h5></h5>
                      </div>
                      <h2 style="text-align: left">{{ $t('ecoeficiencyTable') }}</h2>
                      <div style="padding-top: 15px; padding-bottom: 15px;"></div> 
                      <!-- Tabla de costes --->
                      <table class="styled-table" style="width: 100%;">
                        <thead>
                          <tr>
                            <th scope="col" id="firstColumn"></th>
                            <th scope="col" style="text-align: center;">{{ $t('ecoCIIindex') }}</th>
                            <th scope="col" style="text-align: center;">{{ $t('ecoETSIndex') }}</th>
                            <th scope="col" style="text-align: center;">{{ $t('ecoFuelEUIndex') }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(item, index) in mod.ecoefficiencyIndices" :key="index">
                          <td>
                            <p style="text-align: left">{{ item.year }}</p>
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.indexCII }}</p>
                            <!-- <input class="input-style" v-model="item.FCvoyage" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.indexETS }}</p>
                            <!-- <input class="input-style" v-model="item.FCboiler" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.indexFuelEU }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          </tr>
                        </tbody>
                      </table>
                    <!-- <div class="seperator" v-if="index != (ship.modifications.length - 1)">
                      <h5></h5>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
            </div>

          <!-- Evaluaciones y sanciones finales -->
          <div class="formgrid grid" data-page-break="true">
            <div class="field col" style="padding-left: 4%; padding-right: 4%;">
              <div class="output-box">
                <h1 style="text-align: left;">{{ $t('evaluationsAndSanctions') }}</h1>
                <div style="padding-top: 15px; padding-bottom: 15px;"></div>

                <!-- Tabla del CII anual -->
                <!-- <div class="input-box"> -->
                  <h2 style="text-align: left;">{{ $t('oldRewrittenCII') }} (gCO2/t*mn)</h2>
                  <div style="padding-top: 15px; padding-bottom: 15px;"></div> 
                  <table class="styled-table">
                    <thead>
                      <tr>
                        <th scope="col" id="firstColumn"></th>
                        <th scope="col" style="text-align: center;">{{ $t('carbonIndex') }}</th>
                        <th scope="col" style="text-align: center;">{{ $t('headerCarbonForm') }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in ship.baseCII" :key="index">
                      <td>
                        <p style="text-align: left">{{ item.year }}</p>
                      </td>
                      <td>
                        <p style="text-align: center;">{{ item.value }}</p>
                        <!-- <input class="input-style" v-model="item.FCvoyage" type="number" /> -->
                      </td>
                      <td>
                        <p style="text-align: center;">{{ item.letter }}</p>
                        <!-- <input class="input-style" v-model="item.FCboiler" type="number" /> -->
                      </td>
                      </tr>
                    </tbody>
                  </table>  
                <!-- </div> -->
                
                <div class="seperator" style="padding-bottom: 30px;">
                  <h5></h5>
                </div>

                <!-- Coste del ETS -->
                <!-- <div class="input-box"> -->
                  <h2 style="text-align: left;">{{ $t('label_ETS') }}</h2>
                  <div style="padding-top: 15px; padding-bottom: 15px;"></div> 
                  <table class="styled-table">
                    <thead>
                      <tr>
                        <th scope="col" id="firstColumn"></th>
                        <th scope="col" style="text-align: center;">{{ $t('anualEmissions') }}</th>
                        <th scope="col" style="text-align: center;">{{ $t('emissionRights') }}</th>
                        <th scope="col" style="text-align: center;">{{ $t('costEUA') }} - (€)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in ship.baseETS" :key="index">
                      <td>
                        <p style="text-align: left">{{ item.year }}</p>
                      </td>
                      <td>
                        <p style="text-align: center;">{{ item.anualEmissions }}</p>
                        <!-- <input class="input-style" v-model="item.FCvoyage" type="number" /> -->
                      </td>
                      <td>
                        <p style="text-align: center;">{{ item.emissionRights }}</p>
                        <!-- <input class="input-style" v-model="item.FCboiler" type="number" /> -->
                      </td>
                      <td>
                        <p style="text-align: center;">{{ item.costEUA }}</p>
                        <!-- <input class="input-style" v-model="item.FCboiler" type="number" /> -->
                      </td>
                      </tr>
                    </tbody>
                  </table>  
                <!-- </div> -->

                <div class="seperator" style="padding-bottom: 30px;">
                  <h5></h5>
                </div>

                <!-- Sancion del FuelEU -->
                <!-- <div class="input-box"> -->
                  <h2 style="text-align: left;">{{ $t('label_FuelEU') }}</h2>
                  <div style="padding-top: 15px; padding-bottom: 15px;"></div> 
                  <table class="styled-table">
                      <thead>
                        <tr>
                          <th scope="col" id="firstColumn"></th>
                          <th scope="col" style="text-align: center;">WtT (Well to Tank) (gCO2 eq/MJ)</th>
                          <th scope="col" style="text-align: center;">TtW (Tank to Wake) (gCO2 eq/MJ)</th>
                          <th scope="col" style="text-align: center;">GHG target (gCO2 eq/MJ)</th>
                          <th scope="col" style="text-align: center;">GHG intensity (gCO2 eq/MJ)</th>
                          <th scope="col" style="text-align: center;">{{ $t('Compliance balance') }}</th>
                          <th scope="col" style="text-align: center;">{{ $t('sanctionFuelCost') }}</th>
                          <th scope="col" style="text-align: center;">Compliance Surplus</th>
                          <th scope="col" style="text-align: center;">Compliance Deficit</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item, index) in ship.baseFuelEU" :key="index">
                          <td>
                            <p style="text-align: left">{{ item.year }}</p>
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.wellToTank }}</p>
                            <!-- <input class="input-style" v-model="item.FCvoyage" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.tankToWake }}</p>
                            <!-- <input class="input-style" v-model="item.FCboiler" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.ghgTarget }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.ghgIntensity }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.complianceBalance }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.fuelEUPenalty }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.complianceSurplus }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                          <td>
                            <p style="text-align: center;">{{ item.complianceDeficit }}</p>
                            <!-- <input class="input-style" v-model="item.FCothers" type="number" /> -->
                          </td>
                        </tr>
                      </tbody>
                    </table>
                <!-- </div> -->
              </div>
            </div>
          </div>
          <div class="formgrid grid" data-page-break="true">
            <p> </p>
          </div>
        </div>
      </div>
      <div style="padding-left: 75%;">
        <ButtonPrime @click="back()" id="add-button">{{ $t("goBack") }}</ButtonPrime>
      </div>
  </div>
</template>

<script>
import router from "@/router/index";
import store from "@/store/index";
import ShipService from "@/services/ShipService";
import UserService from "@/services/UserService";
import useVuelidate from "@vuelidate/core";
import FuelConsumptionTable from "./FuelConsumptionTable.vue";

import moment from 'moment';

export default {
name: 'ReportGenerator',
  
  setup() {
    return { v$: useVuelidate() };
  },

  components: {
    FuelConsumptionTable
  },

  data() {
      return {
        //datos del usuario
        user : store.getters.currentUser,
        userName : store.getters.currentUser.firstName,
        userLastName : store.getters.currentUser.lastName,
        userCompany : store.getters.currentUser.company,
        userDNI : store.getters.currentUser.dni,
        userCIF : store.getters.currentUser.cif,
        userUid : store.getters.currentUser.uid,
        userFullName : "",

        ships: [],
        shipsAux: [],
        shipsChecked: [],
        selectedModifications: []
      };
  },
  created() {
    this.shipService = ShipService.getInstance();
    this.userService = UserService.getInstance();
  },
  mounted() {
    this.shipsChecked = JSON.parse(localStorage.getItem("shipsChecked") || [])
    this.selectedModifications = JSON.parse(localStorage.getItem("selectedModifications") || [])
    console.log(this.selectedModifications)
    this.shipService.getShips(this.shipsAux)

    setTimeout(
      this.getAllShips()
    , 1000)

    this.userFullName = this.userName + " " + this.userLastName
    
    //console.log("Report - " + this.shipsChecked)
  },
  methods: {
  
  filteredFuelVariables(ship) {
    return ship.dataForCII.arrayFuelVariables.filter(item => item.fuel.fuel.name);
  },

  dtFormat (dt, format) {
    if(dt != null && dt != undefined)
      return moment.utc(dt).format(format)
    else
      return "--/--/----"
  },

  // generalEnergyPercentage(item){
  //   let n = 0, sum = 0
  //   //console.log(sum)
  //   //console.log(item.arrayAuxFuelIce)
  //   item.arrayAuxFuelIce.forEach( (fuel) => {
  //     sum += fuel.additionalEnergyPercentage
  //     n++
  //   })
  //   if(sum == 0)
  //     return 0
  //   else
  //     return (sum/n).toFixed(2)
  // },

  getFCFuel(ship){
    let fuelName = ""
    ship.dataForCII.arrayFuelVariables.forEach((fuel) => {
      if(fuel.typeFCelec.name != "None"){
        fuelName = fuel.fuel.fuel.name
        //console.log(fuelName)
      }
    });
    return fuelName
  },

  getAllShips(){
    this.shipsAux = []
    this.shipService.getShips(this.shipsAux)
    // console.log("THIS.SHIPSAUUUUUUUUUX")
    // console.log(this.shipsAux)
    // console.log("this.shipsAux.length: " + this.shipsAux.length)

    for(let i=0; i< this.shipsAux.length; i++){
        //si este barco es de NEOBUQ (true), lo añadimos
        if(this.shipsAux[i].isNEOBUQ){
          this.ships.push(this.shipsAux[i])
        }
      }
  },

  hasFuelEUTableData(ship){
    let condicionante = false
    ship.baseFuelEU.forEach( (fuelEU) => {
      if(ship.iceClassType.name != "None"){
        if(
          fuelEU.anualDistanceOnIce != 0 ||
          fuelEU.OPS != 0 ||
          fuelEU.windPower != 0 ||
          fuelEU.propulsionPower != 0
        ){
          condicionante = true
        }
      }else{
        if(
          fuelEU.OPS != 0 ||
          fuelEU.windPower != 0 ||
          fuelEU.propulsionPower != 0
        ){
          condicionante = true
        }
      }
    })
    //console.log(condicionante)
    return condicionante
  },

  sortedFuelEUTable(ship){
    let shipAux = ship.baseFuelEU.sort((a, b) => {a.year - b.year})
    let shipsAux2 = []
    shipAux.forEach( (fuelEU) => {
      if(ship.iceClassType.name != "None"){
        if(
          fuelEU.anualDistanceOnIce != 0 ||
          fuelEU.OPS != 0 ||
          fuelEU.windPower != 0 ||
          fuelEU.propulsionPower != 0
        ){
          shipsAux2.push(fuelEU)
        }
      }else{
        if(
          fuelEU.OPS != 0 ||
          fuelEU.windPower != 0 ||
          fuelEU.propulsionPower != 0
        ){
          shipsAux2.push(fuelEU)  
        }
      }
    })
    return shipsAux2
  },

  hasIceNavConsumption(ship){
    let shipSort = ship.baseFuelEU.sort((a, b) => {a.year - b.year})
    let condicionante = false
    shipSort.forEach( (IceNav) => {
      IceNav.arrayAuxFuelIce.forEach((IceNav2) => {
        if(
          IceNav2.additionalEnergyPercentage != 0 ||
          IceNav2.anualIceConsumption != 0
        ){
          condicionante = true
        }
      })
    })
    console.log(condicionante)
    return condicionante
  },

  sortedIceNavConsumption(ship){
    let shipSort = ship.baseFuelEU.sort((a, b) => {a.year - b.year})
    let shipAux = []
    shipSort.forEach( (IceNav, index) => {
      IceNav.arrayAuxFuelIce.forEach( (IceNav2) => {
        //console.log("Additional energy percentage" + IceNav2.additionalEnergyPercentage)
        if(
          IceNav2.additionalEnergyPercentage != 0 ||
          IceNav2.anualIceConsumption != 0
        ){
          //console.log("iteracion: " + index + " ship " + shipSort[index])
          var copia = false
          for(let i=0; i<shipAux.length; i++){
            if(shipAux[i] == shipSort[index]){
              copia = true
            }
          }
          if(!copia)
            shipAux.push(shipSort[index])
        }
      })
    })
    //console.log(shipSort[0])
    
    return shipAux
  },

  modificationSelected(ship){
    var condicionante = true

    //console.log("selected modficiation " + this.selectedModifications[ship])
    if(this.selectedModifications[ship] == null){
      condicionante = false
    }
    
    //console.log("condicionante: " + condicionante)
    return condicionante
  },

  back(){
    router.push({ name: "neobuqHome" });
  },

  
}
};

</script>

<style scoped>
.container {
  display: table;
  width: 100%;
}

#smallTableContainer {  
  width: 80%;
  padding-left: 100px;
}

.tableContainer {
  display: table-cell;
}

.table {
  padding-bottom: 5%;
}

.inserted-table {
  padding-bottom: 5%;
}

.actionButton {
  margin: 2px !important;
}

.out {
  font-weight: 700;
  color: #ff5252;
}
.in {
  font-weight: 700;
  color: #66bb6a;
}

.table-header-content{
  margin-right: 50%;
}

#fleetLabel {
  background-color: #337AFF;
  color: white;
  padding-top: 25px;
}

.fleet-label {
  border-radius:20px;
  width: 160px;
}

.edit-fleet-button{
  margin: 10px !important;
}
.input-box{
  border-style: dotted;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 450px;
}

.input-box-two{
  border-style: dotted;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 450px;
}

.input-fuel-box{
  display: flex;
  border-style: solid;
  padding: 8px;
  width: 130%;
}

.output-box{
  width: 100%;
  border-style: solid;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-left: 4%; 
  padding-right: 4%;
}

.display-flex{
  display: flex;
}

.input-style{
  border-radius: 5px;
  height: 40px;
  width: 150px;
}

.styled-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

/* Estilo de las tablas */
.styled-table th,
.styled-table td {
  padding: 16px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.styled-table th {
  background-color: #f2f2f2;
}

.styled-table tbody tr:last-child td {
  border-bottom: none;
}

.styled-table tbody tr:hover {
  background-color: #f5f5f5;
}

/* Lineas de separacion */
.seperator h5 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1em;
  padding-top: 30px;
}

.seperator h5::before,
.seperator h5::after {
  content: "";
  display: block;
  flex-grow: 1;
  height: 3px;
  background: #000000;
}

.seperatorThin h5 {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 1em;
  padding-top: 30px;
}

.seperatorThin h5::before,
.seperatorThin h5::after {
  content: "";
  display: block;
  flex-grow: 1;
  height: 1px;
  background: #a8a8a8;
}
</style>